import { useMemo } from 'react';

import { prepareRenewInfoCardFile } from 'adapters';

import useGetCurrentUserPaymentProcessor from './useGetCurrentUserPaymentProcessor';

const useGetRenewInfoCardFile = ({ renewInfo }) => {
	const getCurrentUserPaymentProcessor = useGetCurrentUserPaymentProcessor();

	const paymentProcessor = getCurrentUserPaymentProcessor();

	return useMemo(() => {
		return prepareRenewInfoCardFile({ paymentProcessor, renewInfo });
	}, [paymentProcessor, renewInfo]);
};

export default useGetRenewInfoCardFile;
